import { gatewayPhone } from "../../../../../gateways/gatewayPhone";
import { BackendContact } from "@components/virtual-receptionist/contacts/types/bulk-resolver.types";
import { TranscriptionRecord } from "@components/virtual-receptionist/calls/recording/actions/transcription.action";

export type VoiceMailRecord = {
    uid: string;
    from: string | null;
    to: string | null;
    duration: number | null;
    recordingSid: string | null;
    audioUrl: string | null;
    s3Key: string | null;
    contentType: string | null;
    transcription?: TranscriptionRecord | null;
    provider: string | null;
    createdAt: string;
    updatedAt: string;
    contact?: BackendContact | null;
};

export type GetVoiceMailHistoryParams = {
    page?: number;
    limit?: number;
    phoneNumber?: string;
};

export type GetVoiceMailHistoryResponse = {
    data: VoiceMailRecord[];
    total: number;
    page: number;
    limit: number;
    totalPages: number;
};

export const getVoiceMailHistory = async ({
    page = 1,
    limit = 10,
    phoneNumber,
}: GetVoiceMailHistoryParams = {}): Promise<GetVoiceMailHistoryResponse> => {
    const response = await gatewayPhone.get<GetVoiceMailHistoryResponse>(
        "/voice-mail/recorded",
        {
            params: { page, limit, ...(phoneNumber && { phoneNumber }) },
        }
    );

    return response.data;
};